// Common
import Vue from "vue";
import VueRouter from "vue-router";

// Home
import ContactUs from "@/components/ContactUs.vue";
import HomeMain from "@/views/Home/HomeMain";
import LandingPage from "@/views/Home/LandingPage";
import FactFindPage from "@/views/Landlords/B2B/FactFindPage";
import ApplicationMain from "@/views/StageApplication/ApplicationMain";
import ApplicationSuccessPage from "@/views/StageApplication/ApplicationSuccessPage";
import D2CApplicationSuccessPage from "@/views/StageApplication/D2CApplicationSuccessPage";
import FactFind from "@/views/StageFactFind/FactFind";
import QuotationMain from "@/views/StageQuotation/QuotationMain";
import { adobeTargetTriggerView } from "@/common/utils";

// Landlords Common
import {
  credentialsUnavailable,
  extractUrlParams,
  getCurrentStepRoute,
  routingToCorrectJourney,
} from "@/common/navigating";
import { PRODUCT } from "@/constants/common.constants";
import {
  HOME,
  LANDLORDS,
  MPPI,
  TENANTS_CONTENTS,
  TENANTS_LIABILITY,
  RENT_PROTECTION,
} from "@/constants/questionset.constants";
import { ROUTE_NAME } from "@/constants/route.constants";
import { QuestionStore } from "@/store/store";

// Main Layout
import LandlordsLayout from "@/Layouts/LandlordsLayouts/LandlordsLayout";
import MPPILayout from "@/Layouts/MPPILayouts/MPPILayout.vue";
import TenantsLayout from "@/Layouts/TenantsLayouts/TenantsLayout.vue";
import HomeLayout from "@/Layouts/HomeLayouts/HomeLayout.vue";
import RentProtectionLayout from "@/Layouts/RentProtectionLayouts/RentProtectionLayout.vue";
import ErrorLayout from "@/Layouts/ErrorLayouts/ErrorLayout.vue";
import ErrorPage from "@/views/Errors/ErrorPage.vue";

// Landlords B2B
import B2BLandlordsLayout from "@/Layouts/LandlordsLayouts/LandlordsB2BLayouts/Layout.vue";
import B2BLandlordsApplicationLayout from "@/Layouts/LandlordsLayouts/LandlordsB2BLayouts/ApplicationLayout";
import B2BLandlordsQuestionsLayout from "@/Layouts/LandlordsLayouts/LandlordsB2BLayouts/QuestionsLayout";
import B2BLandlordsCompletePage from "@/views/Landlords/B2B/CompletePage";
import B2BLandlordsCoverTypePage from "@/views/Landlords/B2B/CoverTypePage";
import B2BLandlordsPaymentPage from "@/views/Landlords/B2B/PaymentPage";
import B2BLandlordsPropertyDetailsPage from "@/views/Landlords/B2B/PropertyDetailsPage";
import B2BLandlordsYourApplicationPage from "@/views/Landlords/B2B/YourApplicationPage";
import B2BLandlordsYourDetailsPage from "@/views/Landlords/B2B/YourDetailsPage";
import B2BLandlordsYourQuotesPage from "@/views/Landlords/B2B/YourQuotesPage";

// Landlords D2C
import D2CLandlordsLayout from "@/Layouts/LandlordsLayouts/LandlordsD2CLayouts/Layout.vue";
import D2CLandlordsQuestionsLayout from "@/Layouts/LandlordsLayouts/LandlordsD2CLayouts/QuestionsLayout.vue";
import D2CLandLordsCompletePage from "@/views/Landlords/D2C/CompletePage.vue";
import D2CLandlordsCoverDetailsPage from "@/views/Landlords/D2C/CoverDetailsPage.vue";
import D2CLandlordsCoverTypePage from "@/views/Landlords/D2C/CoverTypePage.vue";
import D2CLandlordsPaymentPage from "@/views/Landlords/D2C/PaymentPage.vue";
import D2CLandlordsPropertyDetailPage from "@/views/Landlords/D2C/PropertyDetailsPage.vue";
import D2CLandlordsQuotationResultPage from "@/views/Landlords/D2C/YourQuotesPage.vue";
import D2CLandlordsWelcomePage from "@/views/Landlords/D2C/WelcomePage.vue";
import D2CLandlordsYourApplicationPage from "@/views/Landlords/D2C/YourApplicationPage.vue";
import D2CLandlordsYourDetailsPage from "@/views/Landlords/D2C/YourDetailsPage.vue";

// Tenants Contents B2B
import B2BTenantsContentsLayout from "@/Layouts/TenantsLayouts/B2B/TenantsContentsLayouts/Layout.vue";
import B2BTenantsContentsMainLayout from "@/Layouts/TenantsLayouts/B2B/TenantsContentsLayouts/MainLayout.vue";
import B2BTenantsContentsCompletePage from "@/views/Tenants/B2B/TenantsContents/CompletePage.vue";
import B2BTenantsContentsPaymentPage from "@/views/Tenants/B2B/TenantsContents/PaymentPage.vue";
import B2BTenantsContentsPropertyDetailsPage from "@/views/Tenants/B2B/TenantsContents/PropertyDetailsPage.vue";
import B2BTenantsContentsYourApplicationPage from "@/views/Tenants/B2B/TenantsContents/YourApplicationPage.vue";
import B2BTenantsContentsYourDetailsPage from "@/views/Tenants/B2B/TenantsContents/YourDetailsPage.vue";
import B2BTenantsContentsYourQuotesPage from "@/views/Tenants/B2B/TenantsContents/YourQuotesPage.vue";

// Tenants Liability B2B
import B2BTenantsLiabilityLayout from "@/Layouts/TenantsLayouts/B2B/TenantsLiability/Layout.vue";
import B2BTenantsLiabilityMainLayout from "@/Layouts/TenantsLayouts/B2B/TenantsLiability/MainLayout.vue";
import B2BTenantsLiabilityCompletePage from "@/views/Tenants/B2B/TenantsLiability/CompletePage.vue";
import B2BTenantsLiabilityPaymentPage from "@/views/Tenants/B2B/TenantsLiability/PaymentPage.vue";
import B2BTenantsLiabilityPropertyDetailsPage from "@/views/Tenants/B2B/TenantsLiability/PropertyDetailsPage.vue";
import B2BTenantsLiabilityYourApplicationPage from "@/views/Tenants/B2B/TenantsLiability/YourApplicationPage.vue";
import B2BTenantsLiabilityYourDetailsPage from "@/views/Tenants/B2B/TenantsLiability/YourDetailsPage.vue";
import B2BTenantsLiabilityYourQuotePage from "@/views/Tenants/B2B/TenantsLiability/YourQuotesPage.vue";

// Home B2B
import B2BHomeLayout from "@/Layouts/HomeLayouts/B2B/Layout.vue";
import B2BHomeMainLayout from "@/Layouts/HomeLayouts/B2B/MainLayout.vue";
import B2BHomeCompletePage from "@/views/Home/B2B/CompletePage.vue";
import B2BHomeCoverTypePage from "@/views/Home/B2B/CoverTypePage.vue";
import B2BHomeFactFindPage from "@/views/Home/B2B/FactFindPage.vue";
import B2BHomePaymentPage from "@/views/Home/B2B/PaymentPage.vue";
import B2BHomePropertyDetailsPage from "@/views/Home/B2B/PropertyDetailsPage.vue";
import B2BHomeYourApplicationPage from "@/views/Home/B2B/YourApplicationPage.vue";
import B2BHomeYourDetailsPage from "@/views/Home/B2B/YourDetailsPage.vue";
import B2BHomeYourQuotesPage from "@/views/Home/B2B/YourQuotesPage.vue";

//Rent Protection
import B2BRentProtectionLayout from "@/Layouts/RentProtectionLayouts/B2B/Layout.vue";
import B2BRentProtectionMainLayout from "@/Layouts/RentProtectionLayouts/B2B/MainLayout.vue";
import B2BRentProtectionCompletePage from "@/views/RentProtection/B2B/CompletePage.vue";
import B2BRentProtectionPaymentPage from "@/views/RentProtection/B2B/PaymentPage.vue";
import B2BRentProtectionCoverDetailsPage from "@/views/RentProtection/B2B/CoverDetailsPage.vue";
import B2BRentProtectionYourApplicationPage from "@/views/RentProtection/B2B/YourApplicationPage.vue";
import B2BRentProtectionYourDetailsPage from "@/views/RentProtection/B2B/YourDetailsPage.vue";
import B2BRentProtectionYourQuotesPage from "@/views/RentProtection/B2B/YourQuotesPage.vue";

// MPPI B2B
import B2BMPPILayout from "@/Layouts/MPPILayouts/B2B/Layout.vue";
import B2BMPPIMainLayout from "@/Layouts/MPPILayouts/B2B/MainLayout.vue";
import B2BMPPICompletePage from "@/views/MPPI/B2B/CompletePage.vue";
import B2BMPPICoverDetailsPage from "@/views/MPPI/B2B/CoverDetailsPage.vue";
import B2BMPPIPaymentPage from "@/views/MPPI/B2B/PaymentPage.vue";
import B2BMPPIYourApplicationPage from "@/views/MPPI/B2B/YourApplicationPage.vue";
import B2BMPPIYourDetailsPage from "@/views/MPPI/B2B/YourDetailsPage.vue";
import B2BMPPIYourQuotesPage from "@/views/MPPI/B2B/YourQuotesPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "HomeMain",
    component: HomeMain,
    meta: {
      title: "Paymentshield",
    },
    props: (route) => ({
      urlParams: extractUrlParams(route.query),
    }),
    beforeEnter: async (to, from, next) =>
      await routingToCorrectJourney(to, from, next),
  },
  {
    path: "/home",
    name: "LandingPage",
    component: LandingPage,
    meta: {
      title: "Paymentshield | Home",
      authenticationRequired: false,
    },
    beforeEnter: (_to, _from, next) => {
      QuestionStore.dispatch("setProductId", PRODUCT.Home);
      next();
    },
  },
  {
    path: "/quotation",
    name: "QuotationMain",
    component: QuotationMain,
    meta: {
      title: "Paymentshield | Quote",
    },
  },
  {
    path: "/application",
    name: "ApplicationMain",
    component: ApplicationMain,
    meta: {
      title: "Paymentshield | Apply",
    },
    props: (route) => ({
      commissionSacrifice: +route.query.commissionSacrifice,
      paymentStatus: route.query.payment,
    }),
  },
  {
    path: "/complete",
    name: "Complete",
    component: ApplicationSuccessPage,
    meta: {
      title: "Paymentshield | Success",
      isComplete: true,
    },
  },
  {
    path: "/contact-us",
    name: "ContactUs",
    component: ContactUs,
    meta: {
      title: "Paymentshield | Contact Us",
      authenticationRequired: false,
    },
    beforeEnter: (to, _from, next) => {
      const productId = +to.query.productId ?? PRODUCT.Home;
      QuestionStore.dispatch("setProductId", productId);
      next();
    },
  },
  {
    path: "/application-success",
    name: "Success",
    component: D2CApplicationSuccessPage,
    meta: {
      title: "Paymentshield | Success",
      isComplete: true,
    },
  },
  {
    path: "/factfind",
    name: "FactFind",
    component: FactFind,
    meta: {
      title: "Paymentshield | Fact Find",
    },
  },
  {
    path: "/b2b/home",
    component: HomeLayout,
    children: [
      {
        path: "",
        name: ROUTE_NAME.HOME.B2B.MAIN,
        component: B2BHomeMainLayout,
        beforeEnter: (to, _from, next) => {
          // avoid infinite loop with child routes
          if (to.name !== ROUTE_NAME.HOME.B2B.MAIN) {
            next();
            return;
          }
          next(getCurrentStepRoute("B2B", HOME));
        },
        children: [
          {
            path: "fact-find",
            name: ROUTE_NAME.HOME.B2B.FACT_FIND,
            meta: {
              title: "Paymentshield | Fact Find",
            },
            component: B2BHomeFactFindPage,
          },
          {
            path: "cover",
            name: ROUTE_NAME.HOME.B2B.COVER_TYPE,
            meta: {
              title: "Paymentshield | Select cover",
            },
            component: B2BHomeCoverTypePage,
          },
          {
            path: "quotation",
            component: B2BHomeLayout,
            children: [
              {
                path: "your-details",
                name: ROUTE_NAME.HOME.B2B.YOUR_DETAILS,
                meta: {
                  title: "Paymentshield | Your details",
                },
                component: B2BHomeYourDetailsPage,
              },
              {
                path: "property-details",
                name: ROUTE_NAME.HOME.B2B.PROPERTY_DETAILS,
                meta: {
                  title: "Paymentshield | Property details",
                },
                component: B2BHomePropertyDetailsPage,
              },
              {
                path: "your-quotes",
                name: ROUTE_NAME.HOME.B2B.QUOTATION_RESULT,
                meta: {
                  title: "Paymentshield | Your quotes",
                },
                component: B2BHomeYourQuotesPage,
              },
            ],
          },
          {
            path: "application",
            component: B2BHomeLayout,
            children: [
              {
                path: "your-application",
                name: ROUTE_NAME.HOME.B2B.APPLICATION,
                meta: {
                  title: "Paymentshield | Your application",
                },
                component: B2BHomeYourApplicationPage,
              },
              {
                path: "payment",
                name: ROUTE_NAME.HOME.B2B.PAYMENT,
                meta: {
                  title: "Paymentshield | Payment",
                },
                component: B2BHomePaymentPage,
              },
            ],
          },
          {
            path: "complete",
            name: ROUTE_NAME.HOME.B2B.COMPLETE,
            meta: {
              title: "Paymentshield | Success",
              isComplete: true,
            },
            component: B2BHomeCompletePage,
          },
        ],
      },
    ],
  },
  {
    path: "/b2b/landlords",
    component: LandlordsLayout,
    children: [
      {
        path: "",
        name: ROUTE_NAME.LANDLORDS.B2B.MAIN,
        component: B2BLandlordsLayout,
        beforeEnter: (to, _from, next) => {
          // avoid infinite loop with child routes
          if (to.name !== ROUTE_NAME.LANDLORDS.B2B.MAIN) {
            next();
            return;
          }
          next(getCurrentStepRoute("B2B", LANDLORDS));
        },
        children: [
          {
            path: "fact-find",
            name: ROUTE_NAME.LANDLORDS.B2B.FACT_FIND,
            meta: {
              title: "Paymentshield | Fact Find",
            },
            component: FactFindPage,
          },
          {
            path: "cover",
            name: ROUTE_NAME.LANDLORDS.B2B.COVER_TYPE,
            meta: {
              title: "Paymentshield | Select cover",
            },
            component: B2BLandlordsCoverTypePage,
          },
          {
            path: "quotation",
            component: B2BLandlordsQuestionsLayout,
            children: [
              {
                path: "your-details",
                name: ROUTE_NAME.LANDLORDS.B2B.YOUR_DETAILS,
                meta: {
                  title: "Paymentshield | Your details",
                },
                component: B2BLandlordsYourDetailsPage,
              },
              {
                path: "property-details",
                name: ROUTE_NAME.LANDLORDS.B2B.PROPERTY_DETAILS,
                meta: {
                  title: "Paymentshield | Property details",
                },
                component: B2BLandlordsPropertyDetailsPage,
              },
              {
                path: "your-quotes",
                name: ROUTE_NAME.LANDLORDS.B2B.QUOTATION_RESULT,
                meta: {
                  title: "Paymentshield | Your quotes",
                },
                component: B2BLandlordsYourQuotesPage,
              },
            ],
          },
          {
            path: "application",
            component: B2BLandlordsApplicationLayout,
            children: [
              {
                path: "your-application",
                name: ROUTE_NAME.LANDLORDS.B2B.APPLICATION,
                meta: {
                  title: "Paymentshield | Your application",
                },
                component: B2BLandlordsYourApplicationPage,
              },
              {
                path: "payment",
                name: ROUTE_NAME.LANDLORDS.B2B.PAYMENT,
                meta: {
                  title: "Paymentshield | Payment",
                },
                component: B2BLandlordsPaymentPage,
              },
            ],
          },
          {
            path: "complete",
            name: ROUTE_NAME.LANDLORDS.B2B.COMPLETE,
            meta: {
              title: "Paymentshield | Success",
              isComplete: true,
            },
            component: B2BLandlordsCompletePage,
          },
        ],
      },
    ],
  },
  {
    path: "/d2c/landlords",
    component: LandlordsLayout,
    children: [
      {
        path: "welcome",
        name: ROUTE_NAME.LANDLORDS.D2C.LANDING_PAGE,
        meta: {
          title: "Paymentshield | Welcome",
          authenticationRequired: false,
        },
        component: D2CLandlordsWelcomePage,
        beforeEnter: (_to, _from, next) => {
          QuestionStore.dispatch("setProductId", PRODUCT.LandLord);
          next();
        },
      },
      {
        path: "",
        name: ROUTE_NAME.LANDLORDS.D2C.MAIN,
        component: D2CLandlordsLayout,
        beforeEnter: (to, _from, next) => {
          // avoid infinite loop with child routes
          if (to.name !== ROUTE_NAME.LANDLORDS.D2C.MAIN) {
            next();
            return;
          }
          next(getCurrentStepRoute("D2C", LANDLORDS));
        },
        children: [
          {
            path: "cover",
            name: ROUTE_NAME.LANDLORDS.D2C.COVER_TYPE,
            meta: {
              title: "Paymentshield | Select cover",
            },
            component: D2CLandlordsCoverTypePage,
          },
          {
            path: "quotation",
            component: D2CLandlordsQuestionsLayout,
            children: [
              {
                path: "your-details",
                name: ROUTE_NAME.LANDLORDS.D2C.YOUR_DETAILS,
                meta: {
                  title: "Paymentshield | Your details",
                },
                component: D2CLandlordsYourDetailsPage,
              },
              {
                path: "property-details",
                name: ROUTE_NAME.LANDLORDS.D2C.PROPERTY_DETAILS,
                meta: {
                  title: "Paymentshield | Property details",
                },
                component: D2CLandlordsPropertyDetailPage,
              },
              {
                path: "cover-details",
                name: "D2CLandlordCoverDetailsPage",
                meta: {
                  title: "Paymentshield | Cover Details",
                },
                component: D2CLandlordsCoverDetailsPage,
              },
            ],
          },
          {
            path: "quotation/your-quotes",
            name: ROUTE_NAME.LANDLORDS.D2C.QUOTATION_RESULT,
            component: D2CLandlordsQuotationResultPage,
            meta: {
              title: "Paymentshield | Quotation Result",
            },
          },
          {
            path: "application",
            component: D2CLandlordsQuestionsLayout,
            children: [
              {
                path: "your-application",
                name: ROUTE_NAME.LANDLORDS.D2C.APPLICATION,
                meta: {
                  title: "Paymentshield | Your application",
                },
                component: D2CLandlordsYourApplicationPage,
              },
            ],
          },
          {
            path: "payment",
            name: ROUTE_NAME.LANDLORDS.D2C.PAYMENT,
            component: D2CLandlordsPaymentPage,
            meta: {
              title: "Paymentshield | Apply",
            },
          },
          {
            path: "complete",
            name: ROUTE_NAME.LANDLORDS.D2C.COMPLETE,
            component: D2CLandLordsCompletePage,
            meta: {
              title: "Paymentshield | Success",
              isComplete: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/b2b/tenants-contents",
    component: TenantsLayout,
    children: [
      {
        path: "",
        name: ROUTE_NAME.TENANTS_CONTENTS.B2B.MAIN,
        component: B2BTenantsContentsMainLayout,
        beforeEnter: (to, _from, next) => {
          // avoid infinite loop with child routes
          if (to.name !== ROUTE_NAME.TENANTS_CONTENTS.B2B.MAIN) {
            next();
            return;
          }
          next(getCurrentStepRoute("B2B", TENANTS_CONTENTS, "YOUR_DETAILS"));
        },
        children: [
          {
            path: "quotation",
            component: B2BTenantsContentsLayout,
            children: [
              {
                path: "your-details",
                name: ROUTE_NAME.TENANTS_CONTENTS.B2B.YOUR_DETAILS,
                meta: {
                  title: "Paymentshield | Your details",
                },
                component: B2BTenantsContentsYourDetailsPage,
              },
              {
                path: "property-details",
                name: ROUTE_NAME.TENANTS_CONTENTS.B2B.PROPERTY_DETAILS,
                meta: {
                  title: "Paymentshield | Property details",
                },
                component: B2BTenantsContentsPropertyDetailsPage,
              },
              {
                path: "your-quotes",
                name: ROUTE_NAME.TENANTS_CONTENTS.B2B.QUOTATION_RESULT,
                meta: {
                  title: "Paymentshield | Your quotes",
                },
                component: B2BTenantsContentsYourQuotesPage,
              },
            ],
          },
          {
            path: "application",
            component: B2BTenantsContentsLayout,
            children: [
              {
                path: "your-application",
                name: ROUTE_NAME.TENANTS_CONTENTS.B2B.APPLICATION,
                meta: {
                  title: "Paymentshield | Your application",
                },
                component: B2BTenantsContentsYourApplicationPage,
              },
              {
                path: "payment",
                name: ROUTE_NAME.TENANTS_CONTENTS.B2B.PAYMENT,
                meta: {
                  title: "Paymentshield | Payment",
                },
                component: B2BTenantsContentsPaymentPage,
              },
            ],
          },
          {
            path: "complete",
            component: B2BTenantsContentsCompletePage,
            name: ROUTE_NAME.TENANTS_CONTENTS.B2B.COMPLETE,
            meta: {
              title: "Paymentshield | Success",
              isComplete: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/b2b/tenants-liability",
    component: TenantsLayout,
    children: [
      {
        path: "",
        name: ROUTE_NAME.TENANTS_LIABILITY.B2B.MAIN,
        component: B2BTenantsLiabilityMainLayout,
        beforeEnter: (to, _from, next) => {
          // avoid infinite loop with child routes
          if (to.name !== ROUTE_NAME.TENANTS_LIABILITY.B2B.MAIN) {
            next();
            return;
          }
          next(getCurrentStepRoute("B2B", TENANTS_LIABILITY, "YOUR_DETAILS"));
        },
        children: [
          {
            path: "quotation",
            component: B2BTenantsLiabilityLayout,
            children: [
              {
                path: "your-details",
                name: ROUTE_NAME.TENANTS_LIABILITY.B2B.YOUR_DETAILS,
                meta: {
                  title: "Paymentshield | Your details",
                },
                component: B2BTenantsLiabilityYourDetailsPage,
              },
              {
                path: "property-details",
                name: ROUTE_NAME.TENANTS_LIABILITY.B2B.PROPERTY_DETAILS,
                meta: {
                  title: "Paymentshield | Property details",
                },
                component: B2BTenantsLiabilityPropertyDetailsPage,
              },
              {
                path: "your-quotes",
                name: ROUTE_NAME.TENANTS_LIABILITY.B2B.QUOTATION_RESULT,
                meta: {
                  title: "Paymentshield | Your quote",
                },
                component: B2BTenantsLiabilityYourQuotePage,
              },
            ],
          },
          {
            path: "application",
            component: B2BTenantsLiabilityLayout,
            children: [
              {
                path: "your-application",
                name: ROUTE_NAME.TENANTS_LIABILITY.B2B.APPLICATION,
                meta: {
                  title: "Paymentshield | Your application",
                },
                component: B2BTenantsLiabilityYourApplicationPage,
              },
              {
                path: "payment",
                name: ROUTE_NAME.TENANTS_LIABILITY.B2B.PAYMENT,
                meta: {
                  title: "Paymentshield | Payment",
                },
                component: B2BTenantsLiabilityPaymentPage,
              },
            ],
          },
          {
            path: "complete",
            component: B2BTenantsLiabilityCompletePage,
            name: ROUTE_NAME.TENANTS_LIABILITY.B2B.COMPLETE,
            meta: {
              title: "Paymentshield | Success",
              isComplete: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/b2b/mppi",
    component: MPPILayout,
    children: [
      {
        path: "",
        name: ROUTE_NAME.MPPI.B2B.MAIN,
        component: B2BMPPIMainLayout,
        beforeEnter: (to, _from, next) => {
          // avoid infinite loop with child routes
          if (to.name !== ROUTE_NAME.MPPI.B2B.MAIN) {
            next();
            return;
          }
          next(getCurrentStepRoute("B2B", MPPI, "YOUR_DETAILS"));
        },
        children: [
          {
            path: "quotation",
            component: B2BMPPILayout,
            children: [
              {
                path: "your-details",
                name: ROUTE_NAME.MPPI.B2B.YOUR_DETAILS,
                meta: {
                  title: "Paymentshield | Your details",
                },
                component: B2BMPPIYourDetailsPage,
              },
              {
                path: "cover-details",
                name: ROUTE_NAME.MPPI.B2B.COVER_DETAILS,
                meta: {
                  title: "Paymentshield | Cover details",
                },
                component: B2BMPPICoverDetailsPage,
              },
              {
                path: "your-quotes",
                name: ROUTE_NAME.MPPI.B2B.QUOTATION_RESULT,
                meta: {
                  title: "Paymentshield | Your quote",
                },
                component: B2BMPPIYourQuotesPage,
              },
            ],
          },
          {
            path: "application",
            component: B2BMPPILayout,
            children: [
              {
                path: "your-application",
                name: ROUTE_NAME.MPPI.B2B.APPLICATION,
                meta: {
                  title: "Paymentshield | Your application",
                },
                component: B2BMPPIYourApplicationPage,
              },
              {
                path: "payment",
                name: ROUTE_NAME.MPPI.B2B.PAYMENT,
                meta: {
                  title: "Paymentshield | Payment",
                },
                component: B2BMPPIPaymentPage,
              },
            ],
          },
          {
            path: "complete",
            component: B2BMPPICompletePage,
            name: ROUTE_NAME.MPPI.B2B.COMPLETE,
            meta: {
              title: "Paymentshield | Success",
              isComplete: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/b2b/rent-protection",
    component: RentProtectionLayout,
    children: [
      {
        path: "",
        name: ROUTE_NAME.RENT_PROTECTION.B2B.MAIN,
        component: B2BRentProtectionMainLayout,
        beforeEnter: (to, _from, next) => {
          // avoid infinite loop with child routes
          if (to.name !== ROUTE_NAME.RENT_PROTECTION.B2B.MAIN) {
            next();
            return;
          }
          next(getCurrentStepRoute("B2B", RENT_PROTECTION, "YOUR_DETAILS"));
        },
        children: [
          {
            path: "quotation",
            component: B2BRentProtectionLayout,
            children: [
              {
                path: "your-details",
                name: ROUTE_NAME.RENT_PROTECTION.B2B.YOUR_DETAILS,
                meta: {
                  title: "Paymentshield | Your details",
                },
                component: B2BRentProtectionYourDetailsPage,
              },
              {
                path: "cover-details",
                name: ROUTE_NAME.RENT_PROTECTION.B2B.COVER_DETAILS,
                meta: {
                  title: "Paymentshield | Cover details",
                },
                component: B2BRentProtectionCoverDetailsPage,
              },
              {
                path: "your-quotes",
                name: ROUTE_NAME.RENT_PROTECTION.B2B.QUOTATION_RESULT,
                meta: {
                  title: "Paymentshield | Your quote",
                },
                component: B2BRentProtectionYourQuotesPage,
              },
            ],
          },
          {
            path: "application",
            component: B2BRentProtectionLayout,
            children: [
              {
                path: "your-application",
                name: ROUTE_NAME.RENT_PROTECTION.B2B.APPLICATION,
                meta: {
                  title: "Paymentshield | Your application",
                },
                component: B2BRentProtectionYourApplicationPage,
              },
              {
                path: "payment",
                name: ROUTE_NAME.RENT_PROTECTION.B2B.PAYMENT,
                meta: {
                  title: "Paymentshield | Payment",
                },
                component: B2BRentProtectionPaymentPage,
              },
            ],
          },
          {
            path: "complete",
            component: B2BRentProtectionCompletePage,
            name: ROUTE_NAME.RENT_PROTECTION.B2B.COMPLETE,
            meta: {
              title: "Paymentshield | Success",
              isComplete: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/error",
    component: ErrorLayout,
    children: [
      {
        path: "",
        name: "ErrorPage",
        component: ErrorPage,
        meta: {
          title: "Paymentshield | Error",
        },
        props: true,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, _, next) => {
  adobeTargetTriggerView(to.path);
  document.title = to.meta.title;
  //default authentication check
  if (
    to.meta.authenticationRequired !== false &&
    credentialsUnavailable(
      extractUrlParams(to.query),
      QuestionStore.getters("hasCredentials")
    )
  ) {
    await QuestionStore.dispatch("exitToAdviserHub");
    return;
  }

  next();
});

export default router;
